import { render, staticRenderFns } from "./rating-number.vue?vue&type=template&id=5a44fa56"
import script from "./rating-number.vue?vue&type=script&lang=js"
export * from "./rating-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports